import _ from 'lodash';
import createTypes from 'utils/createTypes';
import createFetchTypes from 'utils/createFetchTypes';

export default createTypes(
  'API',
  _.flatten([
    createFetchTypes('GET_CONFIGURATION'),
    createFetchTypes('GET_TRANSLATE'),
    createFetchTypes('GET_VIDEO_INFO'),
    createFetchTypes('GET_EPISODES'),
    createFetchTypes('GET_STREAM'),
    createFetchTypes('GET_STREAM_VIRTUAL'),
    createFetchTypes('GET_STREAM_EXTERNAL'),
    createFetchTypes('GET_SUBSCRIPTION_INFO'),
    createFetchTypes('GET_VIDEO_COLLECTION'),
    createFetchTypes('GET_USER'),
    createFetchTypes('GET_USER_HISTORY'),
    createFetchTypes('GET_EPG_TIME'),
    createFetchTypes('GET_EPG_CURRENT'),
    createFetchTypes('GET_EPG'),
    createFetchTypes('GET_CHANNELS'),
    createFetchTypes('POST_AUTH'),
    createFetchTypes('POST_REGISTRATION'),
    createFetchTypes('GET_PAYMENTS_SYSTEM'),
    createFetchTypes('POST_LOGOUT'),
    createFetchTypes('POST_RESTORE'),
    createFetchTypes('POST_CARD_ENCRYPT'),
    createFetchTypes('POST_3RD_PARTY_AUTH'),
    createFetchTypes('POST_3RD_PARTY_REGISTRATION'),
    createFetchTypes('POST_3RD_LOGOUT'),
  ])
);
